import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const ISTEXT = () => {
  return (
    <CardSection id="ISTEXT" title="ISTEXT">
      <Paragraph>
        지정된 열 내의 텍스트를 확인합니다. 텍스트, 공백 또는 null이 발견되면{" "}
        <b>TRUE</b> 값이 반환됩니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>ISTEXT(ARGUMENT)</Paragraph>
        <Ul>
          <Li>
            <b>ARGUMENT</b>는 확인할 열입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>ISTEXT(`Column`)</Paragraph>
        <Img src="computeIsText" />
      </ListSection>
    </CardSection>
  );
};
